<template>
    <b-card class="card-content">
        <div>
            <div id="breadcrumb-field">
                <b-breadcrumb :items="items" />
            </div>
            <b-dropdown
                id="my-profile-dropdown" 
                size="lg"  
                variant="link" 
                toggle-class="text-decoration-none" 
                no-caret
            >
                <template #button-content>
                    <div id="user-field">
                        <div class="user-field__info">
                            <span>{{ loggedUser.nome }}</span>
                            <b-badge 
                                variant="danger"
                                style="width: fit-content;"
                            >
                                <small>{{ loggedUser.perfil.perfil }}</small>
                            </b-badge>
                        </div>
                        <!-- <b-avatar /> -->
                    </div>
                </template>
                <b-dropdown-item to="/my-profile">Meu Perfil</b-dropdown-item>
                <b-dropdown-item @click="resetSession">Sair</b-dropdown-item>
            </b-dropdown>
        </div>
    </b-card>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const items = ref([])

watch(() => route.meta.breadcrumb, (newBreadcrumb) => {
    items.value = newBreadcrumb || []
}, { immediate: true })
</script>

<script>
import { /* BAvatar, */ BBadge, BBreadcrumb, BCard, BDropdown, BDropdownItem } from 'bootstrap-vue-3';
import Cookies from 'js-cookie';

export default {
    name: 'TopBar',
    components: {
        BCard,
        // BAvatar,
        BDropdown,
        BDropdownItem,
        BBadge,
        BBreadcrumb,
    },
    data() {
        return {
            loggedUser: JSON.parse(Cookies.get('session')).user
        }
    },
    methods: {
        resetSession() {
            sessionStorage.clear();
            Cookies.remove('session');
            window.location.href = '/';
        }
    }
}
</script>

<style scoped>

.card-content {
    display: flex;
    justify-content: center;
    height: 4rem !important;
    margin-top: 1rem;
    margin-bottom: 3rem;
    padding: 0 !important;
}

.card-content div {
    display: flex;
    width: 100%;
}

#breadcrumb-field {
    display: flex;
    justify-content: start;
    align-items: center;
    font-weight: bold;
    font-size: 1.2rem;
    padding-top: .9rem;
    padding-left: .5rem;
}

li.breadcrumb-item a {
    text-decoration: none !important;
}

.btn-group {
    justify-content: end;
    align-items: center;
}

#user-field {
    display: flex;
    justify-content: end;
    align-items: center;
    gap: .5rem;
}

.user-field__info {
    display: flex;
    flex-direction: column;
    align-items: end;   
}

.user-field__info span {
    color: #2c3e50;
    font-size: 1rem;
    font-weight: bold;
}

.bg-danger {
    color: white !important;
}

</style>
